import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AddFileService } from '../../../../../shared/components/add-file/add-file.service';
import { LocalDB } from '../../../../../shared/utils';
import { NotificationService } from '../../../../shared/services/notification.service';
import { CreditDialogData, creditTitle, hasAttachment } from '../../models/credit-shared.model';
import { CreditOperationsService } from '../../services/credit-operations.service';

@Component({
  selector: 'app-credit-attachment-dialog',
  templateUrl: './credit-attachment-dialog.component.html',
  styleUrls: ['../../styles/credit-dialog.scss'],
  standalone: false,
})
export class CreditAttachmentDialogComponent {
  readonly originEntity = 'Finanzas';

  uploading = false;
  errorMessage = '';
  fileName = '';

  static open(dialog: MatDialog, data: CreditDialogData): Observable<boolean> {
    return dialog.open<CreditAttachmentDialogComponent, CreditDialogData, boolean>(CreditAttachmentDialogComponent, {
      width: '540px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      autoFocus: false,
      data,
    }).afterClosed().pipe(map(result => result === true));
  }

  constructor(
    private dialogRef: MatDialogRef<CreditAttachmentDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: CreditDialogData,
    private addFileService: AddFileService,
    private operations: CreditOperationsService,
    private notify: NotificationService,
  ) { }

  get subtitle(): string {
    return creditTitle(this.data.kind, this.data.credit);
  }

  get hasFile(): boolean {
    return hasAttachment(this.data.kind, this.data.credit);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length ? input.files[0] : null;
    input.value = '';
    if (!file || this.uploading) return;

    this.fileName = file.name;
    this.errorMessage = '';
    this.uploading = true;
    this.dialogRef.disableClose = true;

    const formData = new FormData();
    formData.append('file', file, file.name);

    this.addFileService.attachFile(formData, this.originEntity)
      .then(response => {
        if (!response || response.error) {
          throw { message: response && response.message };
        }
        LocalDB.RemoveForFiles();
        return this.operations.attachFile(this.data.kind, this.data.credit.uid, response.uid);
      })
      .then(() => {
        this.uploading = false;
        this.dialogRef.disableClose = false;
        this.notify.ok('Cuadro de amortización adjuntado correctamente');
        this.dialogRef.close(true);
      })
      .catch(error => {
        this.uploading = false;
        this.dialogRef.disableClose = false;
        const serverMessage = (error && error.error && error.error.message) || (error && error.message);
        this.errorMessage = serverMessage || 'No se ha podido adjuntar el fichero';
      });
  }

  close(): void {
    if (this.uploading) return;
    this.dialogRef.close(false);
  }
}
